import {html, type TemplateResult} from "lit";
import {customElement} from "lit/decorators.js";
import {unsafeHTML} from "lit/directives/unsafe-html.js";
import {eopCustomEvent} from "../../../common/utils/events";
import {CLOSE_DIALOG} from "./modalDialog";
import {resolve} from "../../../container";
import {ClickTracking} from "../../../tracking/clickTracking";
import {UnLitElement} from "../../../common/elements";

@customElement("eop-disclaimer-dialog-content")
export class DisclaimerDialogContent extends UnLitElement {

    public constructor(
        private headline: string,
        private content: string,
        private url: string,
        private acceptLabel: string,
        private declineLabel: string,
        private clickTracking: ClickTracking = resolve(ClickTracking)
    ) {
        super();
    }

    public render(): TemplateResult {
        return html`
                <div class="modal-dialog disclaimer-dialog">
                    <div class="layer-section layer-section-background-white">
                    <h2 class="h">${this.headline}</h2>
                    <div>${unsafeHTML(this.content)}</div>
                    <div class="disclaimer-footer">
                        <a href=${this.url} target="_blank" class="uni-button primary button-ok" @click=${this.acceptCallback}>
                            ${this.acceptLabel}
                        </a>
                        <button type="button" class="uni-button secondary button-cancel" @click=${this.declineCallback}>
                            ${this.declineLabel}
                        </button>
                    </div>
                </div>
            </div>
        `;
    }

    private acceptCallback(event: Event): void {
        this.trackButton(event, this.acceptLabel);
    }

    private declineCallback(event: Event): void {
        this.trackButton(event, this.declineLabel);
        this.dispatchEvent(eopCustomEvent(CLOSE_DIALOG));
    }

    private trackButton(event: Event, text: string): void {
        this.clickTracking.handleButtonInteract(event, text);
    }
}

export namespace DisclaimerDialogFactory {
    export function create(
        headline: string,
        content: string,
        url: string,
        acceptLabel: string,
        declineLabel: string
    ): DisclaimerDialogContent {
        return new DisclaimerDialogContent(headline, content, url, acceptLabel, declineLabel);
    }
}